export default function displayNameForProduct(product: {
  name: string
  brand?: { name: string; slug: string }
}): string {
  return product.brand?.name
    ? `${product.brand.name} - ${product.name}`
    : product.name
}
